(function () {
  'use strict';
  if (window.__zaehler) return;
  window.__zaehler = true;
  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function knotenMitZahl(el) {
    var lauf = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), k;
    while ((k = lauf.nextNode())) if (/\d/.test(k.nodeValue)) return k;
    return null;
  }
  function einrichten(el) {
    if (el.__zl) return el.__zl;
    var k = knotenMitZahl(el);
    var m = k && k.nodeValue.match(/\d{1,3}(?:\.\d{3})+|\d+/);
    if (!m) return (el.__zl = { aus: true });
    var roh = m[0], bis = parseInt(roh.replace(/\./g, ''), 10);
    var jahr = /^(19|20)\d\d$/.test(roh);
    el.__zl = {
      knoten: k, vor: k.nodeValue.slice(0, m.index), nach: k.nodeValue.slice(m.index + roh.length),
      bis: bis, von: jahr ? bis - 6 : 0, punkte: roh.indexOf('.') > -1, laeuft: false
    };
    return el.__zl;
  }
  function format(z, w) {
    var s = String(z);
    return w.punkte ? s.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : s;
  }
  function laufe(el) {
    var w = el.__zl;
    if (!w || w.aus || w.laeuft) return;
    w.laeuft = true;
    var t0 = null, d = 1800;
    function schritt(ts) {
      if (t0 === null) t0 = ts;
      var t = Math.min(1, (ts - t0) / d), e = 1 - Math.pow(1 - t, 3);
      w.knoten.nodeValue = w.vor + format(Math.round(w.von + (w.bis - w.von) * e), w) + w.nach;
      if (t < 1) requestAnimationFrame(schritt); else w.laeuft = false;
    }
    requestAnimationFrame(schritt);
  }
  var gesehen = window.IntersectionObserver ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      gesehen.unobserve(e.target);
      laufe(e.target);
    });
  }, { threshold: 0.5 }) : null;

  function start() {
    if (ruhig) return;
    document.querySelectorAll('[data-zaehler]').forEach(function (el) {
      if (el.__zl) return;
      var w = einrichten(el);
      if (w.aus) return;
      w.knoten.nodeValue = w.vor + format(w.von, w) + w.nach;
      if (gesehen) gesehen.observe(el); else laufe(el);
      (el.closest('[data-zaehler-flaeche]') || el).addEventListener('mouseenter', function () { laufe(el); });
    });
  }
  document.addEventListener('shopify:section:load', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
